import { ReactComponent as FriendsIcon } from "assets/img/friends/welcome.svg";
import { Button } from "components/elements";

type NoFriendsProps = {
    setModalOpen: (isOpen: boolean) => void;
};

export const NoFriendRequests = ({ setModalOpen }: NoFriendsProps) => {
    return (
        <div className="flex h-4/6 flex-col items-center justify-center rounded-2xl border border-[#c8c8c8] bg-white p-6 text-center">
            <div className="mb-4">
                <div className="">
                    <FriendsIcon className="h-20 w-20" />
                </div>
            </div>
            <h2 className="mb-2 text-lg font-semibold">You don't have any new friend requests</h2>
            {/*<p className="mb-4 text-sm text-gray-500">
                Would you like to add a new friend to your list?
            </p>*/}
            {/*<Button onClick={() => setModalOpen(true)} variant="primary">
                Find New Friend
            </Button>*/}
        </div>
    );
};
